var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "lang-select",
      attrs: {
        role: "navigation",
        "aria-label": "Select language / Vælg sprog"
      }
    },
    [
      _c(
        "a",
        {
          staticClass: "lang-select__anchor",
          class: { "is-selected": !_vm.isDanish },
          attrs: {
            href: "/english/",
            lang: "en",
            "aria-label": "English homepage",
            "aria-current": !_vm.isDanish ? "true" : "",
            "aria-hidden": _vm.disableFocus,
            tabindex: _vm.tabIndex
          }
        },
        [_vm._v("\n        ENG\n    ")]
      ),
      _vm._v("\n     / \n    "),
      _c(
        "a",
        {
          staticClass: "lang-select__anchor",
          class: { "is-selected": _vm.isDanish },
          attrs: {
            href: "/",
            lang: "da",
            "aria-label": "Dansk hjemmeside",
            "aria-current": _vm.isDanish ? "true" : "",
            "aria-hidden": _vm.disableFocus,
            tabindex: _vm.tabIndex
          }
        },
        [_vm._v("\n        DK\n    ")]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }